var _g, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIllustrationWaterHeater(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3158_27824)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40.5391,
    cy: 40.292,
    r: 19.9453,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.3223,
    cy: 40.0762,
    r: 14,
    fill: "url(#paint0_linear_3158_27824)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.9269 47.9469L46.9381 47.9393L46.9487 47.9309C47.1071 47.8046 47.2654 47.5891 47.2654 47.3076V31.4456C47.2654 31.0257 46.9239 30.6842 46.504 30.6842H46.5038H34.5716C34.1517 30.6842 33.8102 31.0257 33.8102 31.4456V47.3076C33.8102 47.5626 33.9258 47.7983 34.1509 47.9484L34.345 47.6572L34.1486 47.9469C36.0599 49.2426 38.3098 49.8997 40.5378 49.8997C42.7658 49.8997 45.0157 49.2418 46.9269 47.9469ZM45.7423 32.2071V46.9098C42.5789 48.8803 38.4965 48.8803 35.3331 46.9098V32.2071H45.7423Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5371 44.3136C39.8069 44.3136 39.2101 44.9104 39.2101 45.6406C39.2101 46.3709 39.8069 46.9676 40.5371 46.9676C41.2673 46.9676 41.8641 46.3709 41.8641 45.6406C41.8641 44.8893 41.2664 44.3136 40.5371 44.3136ZM40.5371 45.9594C40.3616 45.9594 40.2183 45.8161 40.2183 45.6406C40.2183 45.4652 40.3617 45.3218 40.5371 45.3218C40.7125 45.3218 40.8559 45.4652 40.8559 45.6406C40.8559 45.8161 40.7125 45.9594 40.5371 45.9594Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.185339
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6722 39.8293L42.6724 39.8294L42.6781 39.8187C43.0662 39.0917 43.0414 38.2594 42.6049 37.5559L42.6049 37.5559L42.6029 37.5526L41.2038 35.3516L41.2038 35.3515L41.2002 35.3461C41.0494 35.1184 40.8127 35.0045 40.5588 35.0045C40.3038 35.0045 40.0681 35.1201 39.918 35.3452L39.918 35.3451L39.9139 35.3516L38.5148 37.5526L38.5148 37.5526L38.5129 37.5557C38.0815 38.25 38.0263 39.0844 38.4404 39.8204C38.8353 40.5793 39.6583 41.0534 40.5387 41.0534H40.5387C41.425 41.0534 42.2402 40.5751 42.6722 39.8293ZM39.7321 39.0687C39.6181 38.8656 39.6193 38.611 39.7677 38.3555L40.5387 37.154L41.3125 38.3598C41.4532 38.5863 41.4651 38.843 41.3402 39.0782L41.3397 39.0792C41.2035 39.3376 40.9229 39.5095 40.5387 39.5095C40.1648 39.5095 39.8924 39.3449 39.7321 39.0687Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.7
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3158_27824",
    x: 0.59375,
    y: 0.34668,
    width: 79.8906,
    height: 79.8906,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.114844 0 0 0 0 0.222396 0 0 0 0 0.4375 0 0 0 0.54 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3158_27824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3158_27824",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3158_27824",
    x1: 51.3595,
    y1: 26.6015,
    x2: 20.1853,
    y2: 36.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIllustrationWaterHeater);
export default __webpack_public_path__ + "static/media/home_illustration_water_heater.82bc98412819b65779fbefefec477ec4.svg";
export { ForwardRef as ReactComponent };